import {
  Component,
  OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'pp',
  styleUrls: ['./pp.css'],
  templateUrl: './pp.component.html'
})
export class PaypalComponent implements OnInit {

  public localState: any;
  public preparation: boolean = true;
  public status: string;
  public email: string;
  public key: string;
  public proKey: string;
  constructor(
    public route: ActivatedRoute,
    private http: HttpClient,
    public translate: TranslateService
  ) {
    translate.setDefaultLang('ru');
    translate.use('ru');
  }
  public translatePage(lang) {
    this.translate.use(lang);
  }

  public ngOnInit() {
    this.route
      .data
      .subscribe((data: any) => {
        /**
         * Your resolved data from route.
         */
        this.localState = data.yourData;
      });
    this.route.params.subscribe((data) => {
      console.log('route params', data);
      if (data.status !== 'success') {
        window.location.href = '/';
        return;
      }
      this.status = data.status;
    });
    this.route.queryParams.subscribe((data) => {
      console.log('query params', data);
      this.http.post(remoteApiHost + 'payment/paypal/success', data).subscribe((resp: any) => {
        console.log('response', resp);
        this.email = resp.email;
        this.key = resp.key;
        this.proKey = resp.proKey;
        this.preparation = false;
      }, (err) => {
        console.log(err);
        this.preparation = false;
        this.status = 'error';
      });
    });
    console.log('hello `pp` component');
  }

}



// WEBPACK FOOTER //
// ./src/app/pp/pp.component.ts